// Temp fix for inline-styles pulled through via API
$('.js-staff-content *').each(function() {
  $(this).attr('style', '')
})

/*
 * Used to toggle height of long content (collapsed to max-height by default,
 * click button to expand/contract)
 *
 * Usage:
 * <div id="js-name-of-item" class="c-expandable c-expandable--collapsed">
 *    <div class="c-expandable__content js-expandable-inner">
 *      ...Content goes here
 *    </div>
 *    <a href="#js-name-of-item" class="c-button js-expandable-button">
 *      <span class="js-dynamic-text" data-alttext="Show less">Show more</span>
 *    </a>
 * </div>
 */

var defaultMaxHeight = 500

// Apply initial height onload.
$('.c-expandable--collapsed').each(function (index) {
  defaultMaxHeight = $(this).data('max-height') ? $(this).data('max-height') : defaultMaxHeight
  $(this).css('max-height', defaultMaxHeight)
})

$('.js-expandable-button').on('click', function (e) {
  e.preventDefault()

  // Trigger button
  var t = $(this)

  // Target wrapper defined in href of trigger
  var indexOfHash = t.attr('href').indexOf('#')
  if (indexOfHash < 0) return false;

  // Identify anchor portion of URL
  var anchor = t.attr('href').indexOf('#') > 0 ? '#' + t.attr('href').split('#')[1] : t.attr('href')
  var target = $(anchor)

  defaultMaxHeight = target.data('max-height') ? target.data('max-height') : defaultMaxHeight

  if (target.length) {

    if (target.hasClass('c-expandable--collapsed')) {
      var maxHeight = target.find('.js-expandable-inner').outerHeight(true)
      target.css('max-height', maxHeight).removeClass('c-expandable--collapsed')
      t.addClass('c-button--rotate-icon')
      switchButtonText(t)
    } else {
      target.css('max-height', defaultMaxHeight).addClass('c-expandable--collapsed')
      t.removeClass('c-button--rotate-icon')
      switchButtonText(t)
    }
  }

})


// Looks for .js-dynamic-text span within button and alternates text via data attribute:
function switchButtonText (button) {
  var dynamicText = button.find('.js-dynamic-text')
  if (dynamicText.length) {
    var currentText = dynamicText.text()
    var altText = dynamicText.data('alttext')

    dynamicText.text(altText).data('alttext', currentText)
  }
}
